// core
import { Component, OnInit, Input } from '@angular/core';

// raptor
import { RaptorCurrencyPipe } from '../../pipes/raptor-currency.pipe';
import { RaptorDecimalPipe } from '../../pipes/raptor-decimal.pipe';

@Component({
  selector: 'open-raptor-increment',
  templateUrl: './raptor-increment.component.html',
  styleUrls: ['./raptor-increment.component.scss']
})
export class RaptorIncrementComponent implements OnInit {
  @Input() form: any;
  @Input() question: any;
  
  questionControl: any;
  max!: number;
  min!: number;
  step!: number;
  rawValue!: number;

  constructor(
    private raptorCurrencyPipe: RaptorCurrencyPipe,
    private raptorDecimalPipe: RaptorDecimalPipe
  ) { }

  ngOnInit(): void {
    this.questionControl = this.form.get(this.question.key);

    if (this.question.type === 'number') {
      this.min = parseInt(this.question.settings.range.min);
      this.max = parseInt(this.question.settings.range.max);
      this.step = parseInt(this.question.settings.range.step);
      this.questionControl.value = this.questionControl.value || this.min;
      this.updateValue(this.questionControl.value);
    } else if (this.question.type === 'choice') {
        this.rawValue = 0;
        this.min = 0;
        this.max = this.question.settings.choices.length - 1;
        this.step = 1;
        this.question.settings.choices.forEach((value: any, index: number) => {
          if (value.value === this.question.data) {
            this.rawValue = index;
          }
        }); 
        this.questionControl.value = this.questionControl.value || this.question.settings.choices[this.min].value;
        this.updateValue(this.rawValue);
    }
  }

  get fieldValue() {
    if (this.question.type === 'number') {
      return this.questionControl.value;
    } else if (this.question.type === 'choice' && typeof this.rawValue === 'number') {
      return this.question.settings.choices[this.rawValue].label;
    }
  }

  public reduce() {
    let newValue = 0;
    if (this.question.type === 'number') {
      newValue = this.getNumericValue(this.questionControl.value) - this.step;
    } else if (this.question.type === 'choice') {
      newValue = this.getNumericValue(this.rawValue) - this.step;
    }

    if (newValue < this.min) {
      newValue = this.min;
    }

    this.updateValue(newValue);
  }

  public increase() {
    let newValue = 0;
    if (this.question.type === 'number') {
      newValue = this.getNumericValue(this.questionControl.value) + this.step;
    } else if (this.question.type === 'choice') {
      newValue = this.getNumericValue(this.rawValue) + this.step;
    }

    if (newValue > this.max) {
      newValue = this.max;
    }
    this.updateValue(newValue);
  }

  updateValue(value: any) {
    let patchedValue: any = {};

    this.rawValue = value;

    if (this.question.type === 'number') {
      if (this.question.settings.format === 'currency') {
        value = this.raptorCurrencyPipe.transform(this.question, value);
      } else {
        value = this.raptorDecimalPipe.transform(this.question, value);
      }
    } else if (this.question.type === 'choice') {
      value = this.question.settings.choices[value].value;
    }

    patchedValue[this.question.key] = value;
    this.form.patchValue(patchedValue, { emitEvent: true });
  }

  getNumericValue(value: any) {
    let rawValue = typeof value === 'string' ? value.replace(/[^0-9.]/g, '').replace(/^0+/, '') : value;
    return parseInt(rawValue, 10);
  }
}
